import React, { useState, useEffect, useContext } from 'react';
import Rest from 'tools/rest';
import { Table, Button, Modal, message, Typography, Form, Row, Col, Input, Select, Space } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import {
  LoadingOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
  ArrowDownOutlined,
  ReloadOutlined,
  SyncOutlined
} from '@ant-design/icons';
import {
  debounce,
  map as _map,
  includes as _includes,
} from 'lodash';
import dayjs from 'dayjs';

import { QueryMixin } from 'components/mobile_query_mixin';
import AgreementCard from 'components/agreement_card';
import { AbilityContext } from 'tools/ability';

const AGREEMENT_DOCUMENT_STATUS_OPTIONS = [
  { value: 'created', label: 'Создан' },
  { value: 'wait_sign', label: 'На подписании' },
  { value: 'signed', label: 'Подписан' },
  { value: 'canceled', label: 'Отменен' },
  { value: 'annuled', label: 'Аннулирован' },
  { value: 'error', label: 'Ошибка' },
];

const { Text } = Typography;
let debounceLoad = null;

const AgreementDocuments = (props) => {
  const query = new QueryMixin(props)
  const ability = useContext(AbilityContext);
  const canUpdateAgreementDocument =
    ability && typeof ability.can === 'function' && ability.can('update', 'AgreementDocument');

  const [documents, setDocuments] = useState([]);
  const [streets, setStreets] = useState([]);
  const [buildings, setBuildings] = useState([]);
  const [entrances, setEntrances] = useState([]);
  const [flats, setFlats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visibleAgreemCard, setVisibleAgreemCard] = useState(false)
  const [search, setSearch] = useState({
    number: query.getParam('number'),
    street_id: query.getParam('street_id') || undefined,
    building_id: query.getParam('building_id') || undefined,
    entrance_id: query.getParam('entrance_id') || undefined,
    flat_id: query.getParam('flat_id') || undefined,
    statuses: query.getParam('statuses') || [],
  });
  const [meta, setMeta] = useState({ page: 1, per: 20, total: 0 });
  const [useDebounce, setUseDebounce] = useState(false)

  const [selectedAgrm, setSelectedAgrm] = useState(null);

  const [statuses, setStatutses] = useState([])

  const [docModalOpen, setDocModalOpen] = useState(false);
  const [docModalRecord, setDocModalRecord] = useState(null);
  const [docModalStatus, setDocModalStatus] = useState(null);
  const [docModalSaving, setDocModalSaving] = useState(false);
  const [syncingDocId, setSyncingDocId] = useState(null);

  useEffect(() => {
    loadStreets();
  }, [])

  useEffect(() => {
    if (selectedAgrm?.number) {
      setVisibleAgreemCard(true)
    } else {
      setVisibleAgreemCard(false)
    }
  }, [selectedAgrm])

  // useEffect(() => {
  //   loadDocuments();
  // }, [meta.page, meta.per]);

  useEffect(() => {
    if (debounceLoad) {
      debounceLoad.cancel();
    }
    debounceLoad = debounce(() => {
      loadDocuments();
    }, 700);

    debounceLoad();

    if (!useDebounce) {
      debounceLoad.flush();
    }
  }, [search, meta.page, meta.per]);

  // useEffect(() => {
  //   loadBuildings();
  // }, [search.street_id])

  // useEffect(() => {
  //   loadFlats(search.building_id);
  //   loadEntrances(search.building_id);
  // }, [search.building_id])

  const loadDocuments = () => {
    setLoading(true);
    const params = {
      page: meta.page,
      per: meta.per,
      search: search,
    };
    query.setParams({
      ...search,
    })
    Rest.get('/api/v1/agreement_documents.json', { params: params })
      .then((response) => {
        const {agreement_documents, statuses, meta} = response.data;
        setDocuments(agreement_documents);
        setStatutses(statuses);
        setMeta(meta);
      })
      .catch(() => { message.error('Ошибка загрузки списка услуг') })
      .finally(() => setLoading(false));
  };

  const loadStreets = () => {
    setLoading(true);
    Rest.get(`/api/v1/addresses.json`)
      .then((response) => {
        const { data } = response;
        const { suggestions } = data;
        setStreets(_map(suggestions, (s) => {
          return { label: s.value, value: s.id, key: s.id }
        }))
      })
      .catch((e) => { console.error('error', e); })
      .finally(() => { setLoading(false); });
  };

  const loadBuildings = (street_id) => {
    setLoading(true);
    Rest.get(`/api/v1/addresses/houses.json?street_id=${street_id}`)
      .then((response) => {
        const { data } = response;
        const { suggestions } = data;
        setBuildings(_map(suggestions, (s) => {
          return { label: s.value, value: s.id };
        }))
      })
      .catch((e) => { console.error('error', e); })
      .finally(() => { setLoading(false); });
  };

  const loadEntrances = (building_id) => {
    setLoading(true);
    Rest.get(`/api/v1/addresses/entrances.json?building_id=${building_id}`)
      .then((response) => {
        const { data } = response;
        setEntrances(_map(data, (v) => {
          return { label: v.name, value: v.entrance_id };
        }))
      })
      .catch((e) => { console.error('error', e); })
      .finally(() => { setLoading(false); });
  };

  const loadFlats = (building_id) => {
    setLoading(true);
    Rest.get(`/api/v1/addresses/flats.json?building_id=${building_id}`)
      .then((response) => {
        const { data } = response;
        setFlats(_map(data, (v) => {
          return { label: v.name, value: v.flat_id };
        }))
      })
      .catch((e) => { console.error('error', e); })
      .finally(() => { setLoading(false); });
  };

  const handleTableChange = (pagination) => {
    setMeta({
      ...meta,
      page: pagination.current,
      per: pagination.pageSize,
    });
  };

  const handleChangeSelector = (value, search_name) => {
    if (search_name == 'street_id') {
      loadBuildings(value);
      search["building_id"] = undefined;
      search["flat_id"] = undefined;
      search["entrance_id"] = undefined;
    };
    if (search_name == 'building_id') {
      loadEntrances(value);
      loadFlats(value);
      search["flat_id"] = undefined;
      search["entrance_id"] = undefined;
    };
    setSearch({ ...search, [search_name]: value });
    setMeta({ ...meta, page: 1 })
  };

  const handleChangeText = (e) => {
    setUseDebounce(true)
    setSearch({
      ...search, [e.target.name]: e.target.value });
    setMeta({ ...meta, page: 1 })
  };

  const handelRefreshDocUrl = (doc_id) => {
    Rest.post(`/api/v1/agreement_documents/${doc_id}/refresh_doc_url.json`)
      .then((response) => {
        const { agreement_document } = response.data;
        const new_documents = _map(documents, (document)=>{
          if (document.id == agreement_document.id) {
            return agreement_document
          } else {
            return document
          }
        })
        setDocuments(new_documents)
      })
      .catch((e) => { console.error('error', e); })
      .finally(() => {  });
  }

  const handleSyncFdocStatus = (doc_id) => {
    setSyncingDocId(doc_id);
    Rest.post(`/api/v1/agreement_documents/${doc_id}/sync_fdoc_status.json`)
      .then((response) => {
        const { agreement_document } = response.data;
        setDocuments((prev) => prev.map((document) => (
          document.id === agreement_document.id ? agreement_document : document
        )));
        message.success('Статус документа синхронизирован');
      })
      .catch((e) => {
        const status = e?.response?.status;
        if (status === 403) {
          message.error('Нет прав на синхронизацию');
        } else {
          message.error('Не удалось синхронизировать статус документа');
        }
      })
      .finally(() => setSyncingDocId(null));
  };

  const openDocModal = (record) => {
    setDocModalRecord(record);
    setDocModalStatus(record.status);
    setDocModalOpen(true);
  };

  const closeDocModal = () => {
    setDocModalOpen(false);
    setDocModalRecord(null);
    setDocModalStatus(null);
    setDocModalSaving(false);
  };

  const saveDocStatus = () => {
    if (!docModalRecord) return;
    setDocModalSaving(true);
    Rest.put(`/api/v1/agreement_documents/${docModalRecord.id}.json`, {
      agreement_document: { status: docModalStatus },
    })
      .then((response) => {
        const { agreement_document: updated } = response.data;
        setDocuments((prev) => prev.map((d) => (d.id === updated.id ? { ...d, ...updated } : d)));
        closeDocModal();
        message.success('Статус сохранён');
      })
      .catch((e) => {
        const status = e?.response?.status;
        const ad = e?.response?.data?.agreement_document;
        const errMsgs = ad?.errors && Object.values(ad.errors).flat().join(', ');
        if (status === 403) {
          message.error('Нет прав на изменение');
        } else if (status === 400 && errMsgs) {
          message.error(errMsgs);
        } else {
          message.error('Не удалось сохранить статус');
        }
        setDocModalSaving(false);
      });
  };

  const columns = [
    { title: '№', dataIndex: 'id', key: 'id' },
    {
      title: 'Договор',
      dataIndex: 'agreement',
      key: 'agreement',
      render: (value) => (
        <div role="presentation" onClick={(e) => e.stopPropagation()}>
          <a
            onClick={(event) => {
              event.stopPropagation();
              setSelectedAgrm(value);
            }}
          >
            {value?.number}
          </a>
        </div>
      )
    },
    {
      title: 'Адрес',
      dataIndex: 'address',
      key: 'address',
      render: (_, record) => (
        <div role="presentation" onClick={(e) => e.stopPropagation()}>
          <Text>{record?.agreement?.address}</Text>
        </div>
      )
    },
    { title: 'Тип', dataIndex: 'doc_type', key: 'doc_type' },
    {
      title: 'Статус',
      dataIndex: 'status_name',
      key: 'status_name',
    },
    { title: 'Название', dataIndex: 'title', key: 'title' },
    { title: 'GUID', dataIndex: 'external_uid', key: 'external_uid' },
    {
      title: 'Архив',
      dataIndex: 'archive',
      key: 'archive',
      render: (value) => (
        <Text>{value ? 'В архиве' : 'Актуальный'}</Text>
      )
    },
    {
      title: 'Создан',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (value) => (value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : null),
    },
    {
      title: 'Файл',
      dataIndex: 'file',
      key: 'file',
      render: (_, record) => (
        <div role="presentation" onClick={(e) => e.stopPropagation()}>
          <div style={{display: 'flex', justifyContent: 'space-evenly'}}>
            {record.can_action &&
              <>
                {record.file_url &&
                  record.url_relevant &&
                  record.file_status == "done" &&
                  <a href={record.file_url}><ArrowDownOutlined /></a>
                }
                {!record.url_relevant &&
                  record.file_status != "performing" &&
                  <ReloadOutlined onClick={(event) => { event.stopPropagation(); handelRefreshDocUrl(record.id); }} />
                }
                {record.file_status == "performing" && <LoadingOutlined />}
              </>
            }
          </div>
        </div>
      ),
    },
    {
      title: 'Синхронизация',
      key: 'sync',
      render: (_, record) => (
        <div role="presentation" onClick={(e) => e.stopPropagation()}>
          {canUpdateAgreementDocument && record.external_uid && (
            syncingDocId === record.id
              ? <LoadingOutlined />
              : (
                <Button
                  type="link"
                  size="small"
                  icon={<SyncOutlined />}
                  onClick={(event) => {
                    event.stopPropagation();
                    handleSyncFdocStatus(record.id);
                  }}
                >
                  Синхр.
                </Button>
              )
          )}
        </div>
      ),
    },
  ];
  return (
    <React.Fragment>
      {visibleAgreemCard &&
        <Modal
          title={
            <React.Fragment>
              <Text>Карточка договора № {selectedAgrm.number}</Text>
              < InfoCircleOutlined
                style={{ marginLeft: '10px' }}
                onClick={() => {
                  GotoAccountButton.gotoAccount(selectedAgrm.uid, '_blank');
                }}
              />
            </React.Fragment>
          }
          open={visibleAgreemCard}
          onCancel={() => { setVisibleAgreemCard(false) }}
          onOk={() => { setVisibleAgreemCard(false) }}
          footer={false}
          width={'95%'}
        >
          <AgreementCard agrm_id={selectedAgrm.agrm_id} />
        </Modal>}
      {docModalRecord && (
        <Modal
          title={`Документ № ${docModalRecord.id}`}
          open={docModalOpen}
          onCancel={closeDocModal}
          footer={[
            <Button key="close" onClick={closeDocModal}>
              Закрыть
            </Button>,
            ...(canUpdateAgreementDocument
              ? [
                  <Button
                    key="save"
                    type="primary"
                    loading={docModalSaving}
                    onClick={saveDocStatus}
                  >
                    Сохранить
                  </Button>,
                ]
              : []),
          ]}
          width={480}
        >
          <Space direction="vertical" style={{ width: '100%' }} size="middle">
            <div>
              <Text type="secondary">Договор</Text>
              <div><Text>{docModalRecord.agreement?.number}</Text></div>
            </div>
            <div>
              <Text type="secondary">Тип</Text>
              <div><Text>{docModalRecord.doc_type}</Text></div>
            </div>
            <div>
              <Text type="secondary">Название</Text>
              <div><Text>{docModalRecord.title}</Text></div>
            </div>
            <div>
              <Text type="secondary">Статус</Text>
              <div style={{ marginTop: 8 }}>
                <Select
                  style={{ width: '100%' }}
                  value={docModalStatus}
                  disabled={!canUpdateAgreementDocument}
                  options={AGREEMENT_DOCUMENT_STATUS_OPTIONS}
                  onChange={(v) => setDocModalStatus(v)}
                />
              </div>
            </div>
            {!canUpdateAgreementDocument && (
              <Text type="secondary">Изменение статуса недоступно для вашей роли</Text>
            )}
          </Space>
        </Modal>
      )}
      <PageHeader title="Электронные документы" />
      <Form
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
      >
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item
              label='Номер договора:'
              labelCol={{ span: 8 }}
              style={{ marginBottom: '5px' }}
            >
              <Input
                name="number"
                value={search.number}
                placeholder="Номер договора"
                onChange={handleChangeText}
              />
            </Form.Item>
            <Form.Item
              labelCol={{ span: 8 }}
              // wrapperCol={{ span: 19 }}
              label={'Статус:'}
              style={{ marginBottom: '5px' }}
            >
              <Select
                allowClear
                showSearch
                mode='multiple'
                value={search.statuses}
                placeholder='Статусы'
                optionFilterProp="children"
                filterOption={(input, option) => _includes(option.label.toLowerCase(), input.toLowerCase())}
                options={statuses}
                onChange={(values) => {
                  setSearch({
                    ...search,
                    statuses: values
                  });
                }}
              />
            </Form.Item>
            {/* <Form.Item
              label='Телефон:'
              labelCol={{ span: 8 }}
              style={{ marginBottom: '5px' }}
            >
              <Input
                controls={false}
                name="phone"
                value={search.phone}
                placeholder="Телефон"
                onChange={this.handleChangeText}
              />
            </Form.Item> */}
          </Col>
          <Col span={6}>
            <Row>
              <Col span={24}>
                <Form.Item
                  label='Улица:'
                  labelCol={{ span: 8 }}
                  //wrapperCol={{ span: 20 }}
                  style={{ marginBottom: '5px' }}
                >
                  <Select
                    allowClear
                    showSearch
                    // key={this.state.key}
                    value={search.street_id == '' ? undefined : search.street_id}
                    placeholder='Улица'
                    optionFilterProp="children"
                    filterOption={(input, option) => _includes(option.label.toLowerCase(), input.toLowerCase())}
                    options={streets}
                    onChange={(value) => { handleChangeSelector(value, 'street_id') }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={8}>
              <Col span={12}>
                <Form.Item
                  label='Дом:'
                  labelCol={{ span: 8 }}
                  style={{ marginBottom: '5px' }}
                >
                  <Select
                    allowClear
                    showSearch
                    disabled={search.street_id ? false : true}
                    value={search.building_id == '' ? undefined : search.building_id}
                    placeholder='дом'
                    optionFilterProp="children"
                    filterOption={(input, option) => _includes(option.label, input)}
                    options={buildings}
                    onChange={(value) => { handleChangeSelector(value, 'building_id') }}
                  />
                </Form.Item>
              </Col>
              {/* <Col span={8}>
                <Form.Item
                  label='Под.:'
                  labelCol={{ span: 8 }}
                  style={{ marginBottom: '5px' }}
                >
                  <Select
                    allowClear
                    showSearch
                    disabled={search.building_id ? false : true}
                    value={search.entrance_id == '' ? undefined : search.entrance_id}
                    placeholder='под.'
                    optionFilterProp="children"
                    filterOption={(input, option) => _includes(option.label, input)}
                    options={entrances}
                    onChange={(value) => { handleChangeSelector(value, 'entrance_id') }}
                  />
                </Form.Item>
              </Col> */}
              <Col span={12}>
                <Form.Item
                  label='Кв.:'
                  labelCol={{ span: 8 }}
                  style={{ marginBottom: '5px' }}
                >
                  <Select
                    allowClear
                    showSearch
                    disabled={search.building_id ? false : true}
                    value={search.flat_id == '' ? undefined : search.flat_id}
                    placeholder='кв.'
                    optionFilterProp="children"
                    filterOption={(input, option) => _includes(option.label, input)}
                    options={flats}
                    onChange={(value) => { handleChangeSelector(value, 'flat_id') }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={6}>
          </Col>
          <Col span={5}>
            {/* <Form.Item
              label='Тарифы:'
              labelCol={{ span: 8 }}
              style={{ marginBottom: '5px' }}
            >
              <Select
                allowClear
                showSearch
                value={search.tar_id == '' ? undefined : search.tar_id}
                placeholder='тариф'
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={this.lb_tarifs}
                onChange={this.handleTarifToChange}
              />
            </Form.Item> */}
          </Col>
        </Row>
      </Form>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={documents}
        loading={loading}
        onChange={handleTableChange}
        onRow={(record) => ({
          onClick: () => openDocModal(record),
          style: { cursor: 'pointer' },
        })}
        pagination={{
          current: meta.page,
          pageSize: meta.per,
          total: meta.total,
          showSizeChanger: true,
        }}
      />
    </React.Fragment>
  );
};

export default AgreementDocuments;
